import { Config } from 'config';
import { setItemToStore } from 'helpers/utils';

//Action types
export const SET_CONFIG = 'SET_CONFIG';
export const REFRESH = 'REFRESH';

//Action ts type
export type ACTIONTYPE = { type: typeof SET_CONFIG; payload: Partial<Config> } | { type: typeof REFRESH };

export const configReducer = (state: Config, action: ACTIONTYPE) => {
  switch (action.type) {
    case SET_CONFIG: {
      const { payload } = action;
      Object.keys(payload).forEach((key) => {
        // openNavbarVertical is responsive state, not a preference — never persisted.
        if (['theme', 'isNavbarVerticalCollapsed'].includes(key)) {
          setItemToStore(key, String(payload[key as keyof Config]));
        }
      });
      return {
        ...state,
        ...payload,
      };
    }
    case REFRESH:
      return {
        ...state,
      };
    default:
      return state;
  }
};
